import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import Titulo from '../../comum/Titulo';
import {buscarPerfis, buscarUsuarios} from '../../../actions/usuario/buscarUsuarios';
import {alterouFiltro, alterouPagina} from '../../../util/filtros';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN} from '../../../security/securityContext';
import Autorizacao from '../../../security/Autorizacao';
import Usuario from './Usuario'
import ModalCadastrarUsuario from './ModalCadastrarUsuario';
import {alterouEmpresa} from '../../../actions/empresa/alterarEmpresaSelecionada';
import PaginacaoUsuarios from '../PaginacaoUsuarios';
import BotoesPaginacaoUsuarios from '../BotoesPaginacaoUsuarios';
import CabecalhoRodapeTabela from '../../comum/CabecalhoRodapeTabela';
import determinarPaginaAtual from '../../../actions/usuario/determinarPaginaAtualUsuarios';
import alterarRegistrosPorPagina from '../../../actions/usuario/alterarRegistrosPorPaginaUsuarios';
import ModalAlterarUsuario from './ModalAlterarUsuario';
import PainelFiltragem from './PainelFiltrosUsuarios';
import ModalCadastrarUsuarioDescontoRota from './ModalCadastrarUsuarioDescontoRota';
import buscarRotas from '../../../actions/rota/buscarRotas';
import ModalRelacionarAgenciaUsuario from './ModalRelacionarAgenciaUsuario';
import buscarAgencias from '../../../actions/agencia/buscarAgencias';
import bloquearUsuario from '../../../actions/usuario/bloquearUsuario';
import desbloquearUsuario from '../../../actions/usuario/desbloquearUsuario';
import ModalCadastrarMotorista from './ModalCadastrarMotorista';
import CampoSelecionarEmpresa from '../../layout/CampoSelecionarEmpresa';
import { gerarHashForString } from '../../../util/stringUtil';
import ModalHistoricoUsuario from './ModalHistoricoUsuario';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table">
        <div id="header-tabela" className="lista-table">
            <div className="row cabecalho-desktop">
                <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">Número</div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Nome</div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Email</div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Empresa</div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Telefone</div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Ações</div>
            </div>
        </div>
    </div>
);

const ModalConfirmacaoBloqueioDesbloqueio = ({usuario, bloquearDesbloquear}) => (
    <div className="modal fade" id="modalConfirmacaoBloqueioDesbloqueio" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacaoBloqueioDesbloqueio" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p><strong>{`Deseja ${usuario.bloqueado ? 'desbloquear' : 'bloquear'} ${usuario.nome}`}</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => bloquearDesbloquear()}>Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.buscarUsuario = this.buscarUsuario.bind(this);
        this.bloquearDesbloquear = this.bloquearDesbloquear.bind(this);
        this.state = {
            usuarioSelecionado: null,
            textoFiltro: null,
            perfis: [],
            linksSelecionadosModalEdicao: [],

        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.buscarUsuario();
            this.props.buscarAgencias(this.props.empresaSelecionada.id);
            this.props.buscarRotas(this.props.empresaSelecionada.id);
            this.props.buscarPerfis().then(resp => this.setState({perfis: resp.payload.data}));
        }
    }


    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
                this.props.alterarRegistrosPorPagina(10);
            }
            this.buscarUsuario()
        }
    }

    buscarUsuario() {
        this.props.buscarUsuarios(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'idUsuario', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'nome', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'email', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'perfil', '');
    }

    bloquearDesbloquear() {
        if (this.props.usuarioSelecionado.bloqueado) {
            this.props.desbloquearUsuario(this.props.usuarioSelecionado.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarUsuario();
                    }
                })
        } else {
            this.props.bloquearUsuario(this.props.usuarioSelecionado.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarUsuario();
                    }
                })
        }
    }

    limparFormulario() {
        this.props.reset('formularioCadastroUsuario');
        this.setState({perfisSelecionados: []})
        this.props.limparPerfis()
        this.buscarUsuario();
    }


    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoUsuario() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-right">
                            <button data-toggle="modal" data-target="#modalCadastrarUsuario"
                                    className="btn btn-laranja">
                                Cadastrar usuário
                            </button>
                            <button onClick={() => this.props.history.push('/painel-cadastro-usuarios-empresa-lote')} className="btn btn-laranja ml-2 mt-sm-2 mt-2 mt-md-0 mt-lg-0 mt-xl-0">
                                Cadatrar usuário em lote
                            </button>
                        </div>
                    </div>
                </div>
            </Autorizacao>)
    }


    exibirTabelaUsuarios() {
        if (this.props.usuarios && this.props.usuarios.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoUsuarios}
                                       BotoesPaginacao={BotoesPaginacaoUsuarios}>
                    <CabecalhoTabela/>
                    <div className="lista-table">
                        {this.exibirUsuarios()}
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
        return <div>Nenhum usuário cadastrado para a empresa</div>;
    }

    exibirUsuarios() {
        return this.props.usuarios
            .map((usuario, index) => <Usuario key={index} usuario={usuario}
                                              indice={index} 
                                              filtrosAdicionados={this.props.filtrosAdicionados} 
                                              preencherModalEdicao={this.preencherModalEdicao.bind(this)} 
                                              perfis={this.state.perfis}
                                              />)
    }

    preencherModalEdicao(usuarioSelecionado) {
        const links = usuarioSelecionado.links.map(it => { return { hash: gerarHashForString(`${it.tipo}`), id: it.id, tipo: it.tipo, url: it.url } });
        this.setState({ linksSelecionadosModalEdicao: links });
    }

    alterarValoresLinksSelecionados(links) {
        this.setState({ linksSelecionadosModalEdicao: links });
    }

    limparLinks() {
        this.setState({ linksSelecionadosModalEdicao: [] });
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Usuários" urlRetorno="/"/>
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                    <li className="nav-item dropdown nome-empresa">
                                        <div className='col-md-6'>
                                            <CampoSelecionarEmpresa/>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Autorizacao>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <div className="col-12 filtro-busca">
                                <PainelFiltragem/>
                            </div>
                            {this.exibirBotaoNovoUsuario()}
                            {this.exibirTabelaUsuarios()}
                        </div>
                    </div>
                    <ModalCadastrarUsuario buscarUsuario={this.buscarUsuario} perfis={this.state.perfis}/>
                    <ModalCadastrarMotorista/>
                    <ModalAlterarUsuario buscarUsuario={this.buscarUsuario} 
                        perfis={this.state.perfis} 
                        linksSelecionados={this.state.linksSelecionadosModalEdicao} 
                        alterarValoresLinksSelecionados={this.alterarValoresLinksSelecionados.bind(this)}
                        limparLinks={this.limparLinks.bind(this)} />
                    <ModalCadastrarUsuarioDescontoRota/>
                    <ModalRelacionarAgenciaUsuario buscarUsuario={this.buscarUsuario}/>
                    <ModalConfirmacaoBloqueioDesbloqueio
                        bloquearDesbloquear={this.bloquearDesbloquear}
                        usuario={this.props.usuarioSelecionado ? this.props.usuarioSelecionado : ''}/>
                    <ModalHistoricoUsuario/>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => {
    return {
        usuarios: state.usuarios.usuarios,
        usuarioSelecionado: state.usuarioSelecionado,
        empresaSelecionada: state.empresaSelecionada,
        perfisSelecionados: state.perfisSelecionados,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        changeFieldValue,
        filtrosAdicionados: state.filtrosAdicionadosUsuarios
    }};


export default connect(mapStateToProps, {
    buscarUsuarios,
    buscarPerfis,
    determinarPaginaAtual,
    alterarRegistrosPorPagina,
    buscarRotas,
    buscarAgencias,
    desbloquearUsuario,
    bloquearUsuario,
})(reduxForm({
    form: 'formularioCadastroUsuario'
})(PainelGerenciarUsuario))
